import { Link } from 'react-router-dom'

// As telas que sairam da barra de baixo quando a Agenda entrou. E um indice, nao
// uma tela de trabalho. Visual do print dela (08/10): cards em grade, cada um
// com a sua cor, icone grande e um texto curto do que tem dentro.
type Item = {
  para: string
  icone: string
  titulo: string
  texto: string
  // fundo do card, fundo do icone, cor da setinha
  cor: { card: string; icone: string; seta: string }
  largo?: 'meio' | 'inteiro'
}

const AZUL = { card: 'from-sky-50 to-white', icone: 'bg-sky-100', seta: 'bg-sky-100 text-sky-700' }
const ROSA = { card: 'from-rose-50 to-white', icone: 'bg-rose-100', seta: 'bg-rose-100 text-rose-700' }
const VERDE = { card: 'from-emerald-50 to-white', icone: 'bg-emerald-100', seta: 'bg-emerald-100 text-emerald-700' }
const LILAS = { card: 'from-violet-50 to-white', icone: 'bg-violet-100', seta: 'bg-violet-100 text-violet-700' }
const OURO = { card: 'from-amber-50 to-white', icone: 'bg-amber-100', seta: 'bg-amber-100 text-amber-700' }

const ITENS: Item[] = [
  // Pedido dela em 09/09: e-mail comercial/telefone que entram no PDF do
  // pedido moram aqui -- primeiro porque e cadastro de conta.
  { para: '/perfil', icone: '👤', titulo: 'Meu perfil', texto: 'Seus dados, preferências e segurança', cor: AZUL },
  // Ciclo 2A (02/10): agenda de compromissos avulsos. A aba Rota e a ROTA;
  // esta e a agenda de horario marcado.
  { para: '/compromissos', icone: '📅', titulo: 'Meus compromissos', texto: 'Agenda e compromissos com hora', cor: ROSA },
  { para: '/produtos', icone: '📦', titulo: 'Produtos', texto: 'Consulte seus produtos por empresa', cor: VERDE },
  { para: '/representadas', icone: '🏢', titulo: 'Fornecedoras', texto: 'Gerencie suas empresas e tabelas', cor: ROSA },
  { para: '/metas', icone: '🎯', titulo: 'Metas', texto: 'Acompanhe e configure suas metas', cor: LILAS },
  { para: '/comissoes', icone: '💰', titulo: 'Comissões', texto: 'Consulte, acompanhe e dê baixa', cor: OURO },
  { para: '/importar', icone: '📥', titulo: 'Importar planilha', texto: 'Importe produtos, clientes e tabelas', cor: AZUL, largo: 'meio' },
  { para: '/importacoes', icone: '🗂️', titulo: 'Histórico de importações', texto: 'Acompanhe suas importações', cor: VERDE, largo: 'meio' },
  // No fim porque a lista segue o uso diario, e ajuda nao e diaria -- mas ela
  // precisa existir DENTRO do app: o representante esta na rua, sem o link da
  // folha a mao, e a duvida aparece justamente quando nao tem quem perguntar.
  // Indique e ganhe (spec 2026-10-11): so a porcentagem, nunca o valor.
  { para: '/indique', icone: '🎁', titulo: 'Indique e ganhe até 20%', texto: 'Indique o CRM e ganhe comissão pela Hotmart', cor: OURO, largo: 'inteiro' },
  { para: '/ajuda', icone: '❓', titulo: 'Como usar o app', texto: 'Guia passo a passo do app', cor: ROSA, largo: 'inteiro' },
]

function Seta({ classe }: { classe: string }) {
  return (
    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-base font-bold ${classe}`} aria-hidden>
      ›
    </span>
  )
}

function IconeGrande({ icone, classe, tamanho = 'h-14 w-14 text-3xl' }: { icone: string; classe: string; tamanho?: string }) {
  return (
    <span className={`flex shrink-0 items-center justify-center rounded-2xl shadow-sm ${tamanho} ${classe}`} aria-hidden>
      {icone}
    </span>
  )
}

export default function Mais() {
  return (
    <section className="space-y-3 p-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h2 className="text-3xl font-bold text-slate-900">Mais</h2>
          <p className="text-sm text-slate-600">Configurações e ferramentas do seu app</p>
        </div>
        <span
          className="miolo-3d flex h-16 w-16 shrink-0 items-center justify-center rounded-3xl text-4xl"
          aria-hidden
        >
          ⚙️
        </span>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {ITENS.map((item) => {
          const fundo = `rounded-2xl border border-white bg-gradient-to-br shadow-sm ${item.cor.card}`
          if (item.largo === 'inteiro') {
            return (
              <Link key={item.para} to={item.para} className={`col-span-2 flex items-center gap-3 p-3 ${fundo}`}>
                <IconeGrande icone={item.icone} classe={item.cor.icone} tamanho="h-12 w-12 text-2xl" />
                <span className="min-w-0 flex-1">
                  <span className="block font-bold text-slate-900">{item.titulo}</span>
                  <span className="block text-xs text-slate-600">{item.texto}</span>
                </span>
                <Seta classe={item.cor.seta} />
              </Link>
            )
          }
          if (item.largo === 'meio') {
            return (
              <Link key={item.para} to={item.para} className={`flex items-start gap-2 p-3 ${fundo}`}>
                <IconeGrande icone={item.icone} classe={item.cor.icone} tamanho="h-11 w-11 text-2xl" />
                <span className="min-w-0 flex-1">
                  <span className="block text-sm font-bold leading-tight text-slate-900">{item.titulo}</span>
                  <span className="mt-0.5 block text-[11px] leading-snug text-slate-600">{item.texto}</span>
                </span>
              </Link>
            )
          }
          return (
            <Link key={item.para} to={item.para} className={`flex flex-col p-3 ${fundo}`}>
              <span className="flex items-start justify-between">
                <IconeGrande icone={item.icone} classe={item.cor.icone} />
                <Seta classe={item.cor.seta} />
              </span>
              <span className="mt-2 block font-bold leading-tight text-slate-900">{item.titulo}</span>
              <span className="mt-0.5 block text-xs leading-snug text-slate-600">{item.texto}</span>
            </Link>
          )
        })}
      </div>
    </section>
  )
}
